import React, { Component } from 'react';
import { message } from 'antd';

import localDb from '@util/localDb';
import { queryWageInfo } from '@api/hr/wage';
import PageEdit from './PageEdit';
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {
        apportion: {
          details: [],
        },
      },
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.getWageInfo();
  }

  getWageInfo = () => {
    queryWageInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageEdit data={dataInfo} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} />;
    }
    return <span />;
  }
}
export default PageInfo;



// WEBPACK FOOTER //
// ./src/components/hr/wage/PageInfo.js